import React from 'react';

/* ==================================================================
   EmptyState
   ------------------------------------------------------------------
   An empty screen is a moment to tell the user what to do next, so
   every one of these takes an action. The abstract mark floats a few
   pixels over several seconds - enough to feel alive, not enough to
   pull the eye off the copy.
   ================================================================== */

export const EmptyArt = {
  briefcase: (
    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
      <rect x="2" y="7" width="20" height="14" rx="2" />
      <path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2" />
    </svg>
  ),
  document: (
    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
      <polyline points="14 2 14 8 20 8" />
      <line x1="16" y1="13" x2="8" y2="13" />
      <line x1="16" y1="17" x2="8" y2="17" />
    </svg>
  ),
  search: (
    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
      <circle cx="11" cy="11" r="7" />
      <line x1="21" y1="21" x2="16.5" y2="16.5" />
    </svg>
  ),
  people: (
    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
    </svg>
  ),
  bookmark: (
    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
      <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z" />
    </svg>
  ),
  rocket: (
    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
      <path d="M12 2c3.5 2.4 5.5 6 5.5 10L12 17l-5.5-5C6.5 8 8.5 4.4 12 2z" />
      <circle cx="12" cy="9" r="2" />
      <path d="M8.5 15.5C7 17 6.5 20 6.5 20s3-.5 4.5-2" />
    </svg>
  ),
};

export default function EmptyState({
  art = 'briefcase',
  title,
  body,
  extra,
  action,
  actionLabel,
  className = '',
  style,
}) {
  const mark = typeof art === 'string' ? EmptyArt[art] || EmptyArt.briefcase : art;

  return (
    <div className={`ui-empty ${className}`.trim()} style={style}>
      <div className="ui-empty__art">{mark}</div>
      {title && <div className="ui-empty__title">{title}</div>}
      {body && <div className="ui-empty__body">{body}</div>}
      {/* Supporting content sits above the action: it is the reason to press it. */}
      {extra && <div className="ui-empty__extra">{extra}</div>}
      {action && actionLabel && (
        <button type="button" className="ui-action ui-action--idle ui-action--md" onClick={action}>
          <span className="ui-action__label">{actionLabel}</span>
        </button>
      )}
    </div>
  );
}
